export const searchColumns = [
  {
    prop: 'bankCode',
    name: '银行代码',
    type: 'input',
  },
  {
    prop: 'branchName',
    name: '分行名称',
    type: 'input',
  },
  {
    prop: 'bankUnionNumber',
    name: '银行联行号',
    type: 'input',
  },
  {
    prop: 'swiftCode',
    name: 'SWIFT码',
    type: 'input',
  },
];

export const defaultMenuBtnList = [
  {
    id: 2,
    label: '启用',
    type: '0',
    attributes: {
      buttonStyle: '',
      buttonUrl: 'enable',
    },
  },
  {
    id: 3,
    label: '禁用',
    type: '0',
    attributes: {
      buttonStyle: '',
      buttonUrl: 'forbid',
    },
  },
  {
    id: 4,
    label: '导入',
    type: '0',
    attributes: {
      buttonStyle: '',
      buttonUrl: 'import',
    },
  },
];

export const defaultTableColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    field: 'bankNmae',
    title: '银行名称',
    visible: true,
  },
  {
    field: 'bankCode',
    title: '银行代码',
    visible: true,
  },
  {
    field: 'bankRegion',
    title: '地区',
    visible: true,
  },
  {
    field: 'bankCity',
    title: '城市',
    visible: true,
  },
  {
    field: 'bankStreet',
    title: '街道',
    visible: true,
  },
  {
    field: 'branchName',
    title: '分行',
    visible: true,
  },
  {
    field: 'bankUnionNumber',
    title: '银行联行号',
    visible: true,
  },
  {
    field: 'swiftCode',
    title: 'SWIFT码',
    visible: true,
  },
  {
    field: 'bankGroup',
    title: '银行组',
    visible: true,
  },
  {
    field: 'bankStatus',
    title: '状态',
    visible: true,
  },
];
